export default __webpack_public_path__ + "static/media/latest-news-img30.d33e610d.jpg";